// extracted by mini-css-extract-plugin
export var caretAnchor = "_vm-0";
export var dropdownContent = "_vm-1";